import React from 'react'
import {connect} from 'react-redux'
import HandsonTable from '../components/HandsonTable'
import DatePicker from 'material-ui/DatePicker'
import RaisedButton from 'material-ui/RaisedButton'
import {MarkerList} from '../config'

import {parseBoltData} from '../utils/table'
import {BoltKeyMap} from '../utils/bolt'

const BoltIdSource = [...MarkerList,'']
const BoltTypeSource = Object.keys(BoltKeyMap).map(key=>BoltKeyMap[key])

const LogbookTestReport = React.createClass({
  displayName: 'LogbookTestReport',
  nestedHeaders: [
  ['','','','','','',{ label: '不合格', colspan: 6 },''],
  ['測試日期','編號','路線','Bolt','Bolt類型','合格','拉力kN','直接斷裂','拉力下降','位移超標','外觀異常','膠異常','測試人員'],
  ],
  columns: [
  { data: 'date', readOnly: true, width:100},
  { data: 'rid', readOnly: true, width:60},
  { data: 'name', readOnly: true, width:100},
  { data: 'bid', readOnly: true, width:60,},
  { data: 'type',  readOnly: true, width:120},
  { data: 'ok', type: 'checkbox', readOnly: true, width:60},
  { data: 'strength', type: 'numeric', readOnly: true, width:100},
  { data: 'brk', type: 'checkbox', readOnly: true, width:100},
  { data: 'drop', type: 'checkbox', readOnly: true, width:100},
  { data: 'deform', type: 'checkbox', readOnly: true, width:100},
  { data: 'crack', type: 'checkbox', readOnly: true, width:100},
  { data: 'glue', type: 'checkbox', readOnly: true, width:100},
  { data: 'tester', readOnly: true, width:200},
  ],


  render() {
    let styles = {
      table:{
        margin:20,
        overflow:'auto',
        height:'100%',
      },
    }

    return (
      <HandsonTable
      ref="table"
      style={styles.table}
      autoUpdate={true}
      nestedHeaders={this.nestedHeaders}
      columns={this.columns}
      data={this.props.list}
      />
      )
  },
})

function mapStateToProps(state,props) {
  let { routes,tests } = state
  let list = []
  Object.keys(tests).reverse().forEach(date=>{
    let report = tests[date]
      Object.keys(report).forEach(id=>{
        let test = {...report[id]}
        test.date = date
        let route = routes[test.rid]
        if(route){
          test.name = route.name
        }
        test.type = BoltKeyMap[test.type]

        list.push(test)
      })
  })

  return {list}
}


export default connect(mapStateToProps)(LogbookTestReport)



/** WEBPACK FOOTER **
 ** ./src/app/containers/LogbookTestReport.js
 **/